import {NgModule} from '@angular/core';

import {NgbAccordionModule} from './accordion/accordion.module';
import {NgbAlertModule} from './alert/alert.module';
import {NgbCarouselModule} from './carousel/carousel.module';
import {NgbCollapseModule} from './collapse/collapse.module';
import {NgbDatepickerModule} from './datepicker/datepicker.module';
import {NgbDropdownModule} from './dropdown/dropdown.module';
import {NgbModalModule} from './modal/modal.module';
import {NgbPaginationModule} from './pagination/pagination.module';
import {NgbPopoverModule} from './popover/popover.module';
import {NgbProgressbarModule} from './progressbar/progressbar.module';
import {NgbdProgressCircleModule} from './progresscircle/progress-circle.module';
import {NgbdTimeoutModule} from './timeout/timeout.module';
import {NgbRatingModule} from './rating/rating.module';
import {NgbTabsetModule} from './tabset/tabset.module';
import {NgbTimepickerModule} from './timepicker/timepicker.module';
import {NgbToastModule} from './toast/toast.module';
import {NgbTooltipModule} from './tooltip/tooltip.module';
import {NgbTypeaheadModule} from './typeahead/typeahead.module';
import {CloNotificationsModule} from './globalnavigation/notifications/notifications.module';
import {CloGlobalMenuModule} from './globalnavigation/global-menu.module';
import {CloApplicationTrayModule} from './globalnavigation/application-tray/application-tray.module';
import {CloButton} from './button/button';
import {CloButtonModule} from './button/button.module';
import {CloButtonsSplit} from './button/buttons-split';
import {CloButtonGroupModule} from './buttongroup/button-group.module';
import {CloBadge} from './badge/badge';
import {CloBadgeModule} from './badge/badge.module';
import {CloInputChoice} from './inputs/choice-input';
import {CloInputText} from './inputs/text-input';
import {CloInputCounter} from './inputs/input.module';
import {CloInputModule} from './inputs/input.module';
import {CloProfileMenu} from './globalnavigation/profile-menu/profile-menu';
import {CloProfileMenuModule} from './globalnavigation/profile-menu/profile-menu.module';
import {CloInputTextarea} from './inputs/textarea-input';
import {CloInputSelect} from './inputs/select-input';
import {CloInputSelectMultiple} from './inputs/select-multiple-input';
import {CloTableModule} from './table/table.module';
import {CloMobileNavigationModule} from './mobilenavigation/mobile-nav.module';
import {CloSecondaryNavigationModule} from './secondarynavigation/secondary-navigation.module';
import {InformationFooterModule} from './informationfooter/info-footer.module';

import {CloStepNavigationModule} from './stepnavigation/stepnavigation.module';
import {StepnavigationitemModule} from './stepnavigation/step-navigation-item/stepnavigationitem.module';
import {DlDateTimeDateModule} from './date-picker/core/dl-date-time-core.module';
import {DlDateTimePickerModule} from './date-picker/dl-date-time-picker/dl-date-time-picker.module';
import {DlDateTimeInputModule} from './date-picker/dl-date-time-input/dl-date-time-input.module';

export {
  NgbAccordion,
  NgbAccordionConfig,
  NgbAccordionModule,
  NgbPanel,
  NgbPanelChangeEvent,
  NgbPanelContent,
  NgbPanelHeader,
  NgbPanelHeaderContext,
  NgbPanelTitle,
  NgbPanelToggle
} from './accordion/accordion.module';
export {CloAlert, CloAlertConfig, NgbAlertModule} from './alert/alert.module';
export {CloButton, CloButtonLabel, CloIconButton} from './button/button.module';
export {CloButtonsSplit} from './button/button.module';
export {CloBadge} from './badge/badge.module';
export {
  NgbCarousel,
  NgbCarouselConfig,
  NgbCarouselModule,
  NgbSlide,
  NgbSlideEvent,
  NgbSlideEventDirection,
  NgbSlideEventSource
} from './carousel/carousel.module';
export {NgbCollapse, NgbCollapseModule} from './collapse/collapse.module';
export {
  NgbCalendar,
  NgbCalendarGregorian,
  NgbCalendarHebrew,
  NgbCalendarIslamicCivil,
  NgbCalendarIslamicUmalqura,
  NgbCalendarPersian,
  NgbDate,
  NgbDateAdapter,
  NgbDateNativeAdapter,
  NgbDateNativeUTCAdapter,
  NgbDateParserFormatter,
  NgbDatepicker,
  NgbDatepickerConfig,
  NgbDatepickerI18n,
  NgbDatepickerI18nHebrew,
  NgbDatepickerModule,
  NgbDatepickerNavigateEvent,
  NgbDateStruct,
  NgbInputDatepicker,
  NgbPeriod
} from './datepicker/datepicker.module';
export {
  NgbDropdown,
  NgbDropdownAnchor,
  NgbDropdownConfig,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownModule,
  NgbDropdownToggle
} from './dropdown/dropdown.module';
// export {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
export {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalConfig,
  NgbModalModule,
  NgbModalOptions,
  NgbModalRef
} from './modal/modal.module';
export {
  NgbPagination,
  NgbPaginationConfig,
  NgbPaginationEllipsis,
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationModule,
  NgbPaginationNext,
  NgbPaginationNumber,
  NgbPaginationPrevious
} from './pagination/pagination.module';
export {NgbPopover, NgbPopoverConfig, NgbPopoverModule} from './popover/popover.module';
export {NgbProgressbar, NgbProgressbarConfig, NgbProgressbarModule} from './progressbar/progressbar.module';
export {NgbdProgressCircleModule} from './progresscircle/progress-circle.module';
export {NgbdTimeoutModule} from './timeout/timeout.module';
export {NgbRating, NgbRatingConfig, NgbRatingModule} from './rating/rating.module';
export {
  NgbTab,
  NgbTabChangeEvent,
  NgbTabContent,
  NgbTabset,
  NgbTabsetConfig,
  NgbTabsetModule,
  NgbTabTitle
} from './tabset/tabset.module';
export {
  CloSecondaryNavigationTab,
  CloSecondaryNavigationTabChangeEvent,
  CloSecondaryNavigationTabContent,
  CloSecondaryNavigation,
  CloSecondaryNavigationModule,
  CloSecondaryNavigationTabTitle
} from './secondarynavigation/secondary-navigation.module';
export {
  NgbTimeAdapter,
  NgbTimepickerI18n,
  NgbTimepicker,
  NgbTimepickerConfig,
  NgbTimepickerModule,
  NgbTimeStruct
} from './timepicker/timepicker.module';
export {NgbToast, NgbToastConfig, NgbToastHeader, NgbToastModule} from './toast/toast.module';
export {NgbTooltip, NgbTooltipConfig, NgbTooltipModule} from './tooltip/tooltip.module';
export {
  NgbHighlight,
  NgbTypeahead,
  NgbTypeaheadConfig,
  NgbTypeaheadModule,
  NgbTypeaheadSelectItemEvent
} from './typeahead/typeahead.module';
export {Placement} from './util/positioning';
export {CloGlobalMenu} from './globalnavigation/global-menu.module';
export {CloNotificationItem, CloNotifications} from './globalnavigation/notifications/notifications.module';
export {CloApplicationTray, CloApplicationTrayItem} from './globalnavigation/application-tray/application-tray.module';
export {CloProfileMenu, CloProfileMenuItem, CloProfileUser} from './globalnavigation/profile-menu/profile-menu.module';
export {
  CloInputChoice,
  CloInputText,
  CloInputTextarea,
  CloInputSelect,
  CloInputSelectMultiple,
  CloInputCounter
} from './inputs/input.module';
export {CloTable} from './table/table.module';
export {CloStepNavigation} from './stepnavigation/stepnavigation.module';
export {CloStepNavigationItem} from './stepnavigation/step-navigation-item/stepnavigationitem.module';
export {CloStepNavigationModule} from './stepnavigation/stepnavigation.module';
// export {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
export {CloMobileNavigationModule} from './mobilenavigation/mobile-nav.module';
export {MobileNavigationMenu} from './mobilenavigation/mobile-nav.module';
export {CloInformationFooter} from './informationfooter/info-footer.module';
export {CloButtonGroupOption, CloButtonGroup} from './buttongroup/button-group.module';

export * from './date-picker/core/public-api'; // './core/public-api';
export * from './date-picker/dl-date-time-input/public-api'; // './dl-date-time-input/public-api';
export * from './date-picker/dl-date-time-picker/public-api'; // './dl-date-time-picker/public-api';

const NGB_MODULES = [
  NgbAccordionModule, NgbAlertModule, NgbCarouselModule, NgbCollapseModule, NgbDatepickerModule,
  NgbDropdownModule, NgbModalModule, NgbPaginationModule, NgbPopoverModule, NgbProgressbarModule, NgbdProgressCircleModule, NgbRatingModule,
  NgbTabsetModule, NgbTimepickerModule, NgbToastModule, NgbTooltipModule, NgbTypeaheadModule, CloNotificationsModule, CloGlobalMenuModule,
  CloApplicationTrayModule, CloButtonModule, CloBadgeModule, CloInputModule, CloProfileMenuModule, CloStepNavigationModule,
  DlDateTimeInputModule, DlDateTimeDateModule, DlDateTimePickerModule, CloTableModule, CloSecondaryNavigationModule,
  StepnavigationitemModule, CloMobileNavigationModule, InformationFooterModule, CloButtonGroupModule, NgbdTimeoutModule

];


@NgModule({imports: NGB_MODULES, exports: NGB_MODULES})
export class CloModule {
}
